import React from 'react'

import Icon from '../../Icon/Icon'

const PreviousLinkElement = () => (
  <span>
    <Icon type="chevron-left" />
    Previous
  </span>
)

export default PreviousLinkElement
